import {createAsyncThunk, createSlice, current} from '@reduxjs/toolkit';
import {deleteBusApi, getAllBusesApi, postBusApi, updateBusApi} from "../../api/backendAPIs";

export const fetchAllBuses = createAsyncThunk('fetchAllBuses', async () => {
    return await getAllBusesApi("page=0&size=2000")
})

export const deleteBus = createAsyncThunk('deleteBus', async (payload) => {
    return deleteBusApi(payload);
})

export const postBus = createAsyncThunk('postBus', async (payload) => {
    return postBusApi(payload);
})

export const updateBus = createAsyncThunk('updateBus', async (payload) => {
    return updateBusApi(payload);
})

const initialState = {
    busesList: [],
    loadingBuses: false,
    searchParam: ""
}

const busesSlice = createSlice({
    name: 'buses',
    initialState,
    reducers: {
        setSearchParam: (state, action) => {
            state.searchParam = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllBuses.pending, (state) => {
                state.loadingBuses = true;
            })
            .addCase(fetchAllBuses.fulfilled, (state, { payload }) => {
                state.loadingBuses = false;
                state.busesList = payload.data.content;
            })
            .addCase(fetchAllBuses.rejected, (state) => {
                state.loadingBuses = false;
            })
            .addCase(deleteBus.pending, (state) => {
                state.loadingBuses = true;
            })
            .addCase(deleteBus.fulfilled, (state, action) => {
                const arr = [...current(state.busesList)];
                const index = arr.findIndex((i) => i.id === action.meta.arg);
                if (index !== -1) {
                    arr.splice(index, 1);
                    state.busesList = arr;
                }
                state.loadingBuses = false;
            })
            .addCase(deleteBus.rejected, (state) => {
                state.loadingBuses = false;
            })
            .addCase(postBus.pending, (state) => {
                state.loadingBuses = false;
            })
            .addCase(postBus.fulfilled, (state, { payload }) => {
                const arr = [...current(state.busesList)];
                arr.push(payload.data);
                state.busesList = arr;
                state.loadingBuses = false;
            })
            .addCase(postBus.rejected, (state) => {
                state.loadingBuses = false;
            })
            .addCase(updateBus.pending, (state) => {
                state.loadingBuses = false;
            })
            .addCase(updateBus.fulfilled, (state, { payload }) => {
                const arr = [...current(state.busesList)];
                const index = arr.findIndex((o) => o.id === payload.data.id);
                if (index !== -1) {
                    arr[index] = payload.data;
                    state.busesList = arr;
                }
                state.loading = false;
            })
            .addCase(updateBus.rejected, (state) => {
                state.loadingBuses = false;
            });
    },
});

export const { setSearchParam } = busesSlice.actions;
export default busesSlice.reducer;
